export default "__VITE_ASSET__ClBDuof5__"